import React from "react";
import { Container, Row, Col } from "reactstrap";
import "../../styles/about-section.css";


const AboutSection = ({ aboutClass }) => {
  return (
    <section
      className="about__section"
      style={
        aboutClass === "aboutPage"
          ? { marginTop: "0px" }
          : { marginTop: "280px" }
      }
    >
      <Container>
        <Row>
          <Col lg="6" md="6">
            <div className="about__section-content">
              <h4 className="section__subtitle">About Us</h4>
              <h2 className="section__title">Welcome to Dabridge Company</h2>
              <p className="section__description">
                We are a customer-focused service company committed to convenience, quality, and affordability.
                Our goal is to simplify everyday needs by offering multiple essential services in one trusted place.
                With experienced professionals, modern equipment, and a passion for excellence, we serve individuals, families, and businesses with reliable solutions they can count on.
              </p>

              <div className="about__section-item d-flex align-items-center">
                <p className="section__description d-flex align-items-center gap-2">
                  <i class="ri-checkbox-circle-line"></i>Experienced & professional staff
                </p>

                <p className="section__description d-flex align-items-center gap-2">
                  <i class="ri-checkbox-circle-line"></i>Affordable pricing
                </p>
              </div>

              <div className="about__section-item d-flex align-items-center">
                <p className="section__description d-flex align-items-center gap-2">
                  <i class="ri-checkbox-circle-line"></i> Customer satisfaction guaranteed
                </p>

                <p className="section__description d-flex align-items-center gap-2">
                  <i class="ri-checkbox-circle-line"></i> Clean, safe, and reliable services
                </p>
              </div>
            </div>
          </Col>

       
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
